import React from "react";
import FedWiresPage from "components/pages/FedWiresPage";

/**
 * @name Capture004WireHistory
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Activity".
 */
export default function Capture004WireHistory() {
  
    return <FedWiresPage />;
}